var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("list-page", {
        attrs: {
          getter: "unsolds",
          "sort-by-prop": "make",
          "sort-by-desc-prop": 0,
          "table-fields": _vm.fields,
          "enable-selection": true,
          disableHead: _vm.disableHead,
          hidePrices: _vm.hidePrices,
          showRepFilter:
            _vm.$userIsRole("super_admin") ||
            (_vm.$userIsRole("sales") &&
              _vm.loggedInUser.shared_sales_rep &&
              _vm.loggedInUser.shared_sales_rep.length),
          userListNullLabel:
            _vm.$userIsRole("super_admin") ||
            (_vm.$userIsRole("sales") &&
              _vm.loggedInUser.shared_sales_rep &&
              _vm.loggedInUser.shared_sales_rep.length)
              ? "All"
              : "-",
          sortByProp: _vm.sold_date,
          sortByDescProp: true,
          filterBySharedSalesReps: true,
          hideAddNew: true
        },
        on: { selectVehicle: _vm.onSelect },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function() {
              return [_vm._v("\n            SBL Unsold Stock\n        ")]
            },
            proxy: true
          },
          {
            key: "right_buttons",
            fn: function() {
              return [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openSendEmailModalFunc()
                      }
                    }
                  },
                  [_vm._v("Send Email")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("vehicle-stock-send-email", {
        attrs: { "vehicle-ids": _vm.selected },
        model: {
          value: _vm.openSendEmailModal,
          callback: function($$v) {
            _vm.openSendEmailModal = $$v
          },
          expression: "openSendEmailModal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33cdd00c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33cdd00c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/UnsoldsStock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-33cdd00c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/UnsoldsStock.vue
// module chunks = 0